/* Marcel Afters, SHOPPABLE pass (28 Sep 2026). Styles: assets/ma-shoppable.css. Loaded deferred from layout/theme.liquid.
   1. Touch: every card that already has a second image for desktop hover (usually the flat lay) gets a small
      "Flat lay" chip; a tap on the chip, or a sideways swipe on a grid card, crossfades to it. A tap on the image
      itself still opens the product. Cards arriving later (filters, infinite scroll, rec lanes) are picked up too.
   2. Editorial images that had no link get one: the landing heroes and the Athletics Club frames open their own
      "Shop the look"; the homepage film opens the Essentials.
   No markup is changed server side, so removing this file (and its two lines in theme.liquid) restores the site. */
(function () {
  'use strict';
  var touch = window.matchMedia('(hover: none), (pointer: coarse)');

  /* ---------- 1. Flat-lay reveal ---------- */
  var FAMILIES = [
    { host: '.card-gallery', back: '.ma-gh__hover', front: 'slideshow-slide img' },
    { host: '.ma-rc__media', back: 'img.ma-rc__back', front: 'img.ma-rc__front', skip: '.ma-rc__flip' },
    { host: '.ma-st__media', back: 'img.ma-st__back', front: '.ma-st__img img:not(.ma-st__back)' },
    { host: '.ma-wear__img.has-flat', back: 'img.ma-wear__f', front: 'img.ma-wear__m', inLink: true },
    { host: '.ma-pairs__img', back: 'img.ma-pairs__hover', front: 'img:not(.ma-pairs__hover)', inLink: true }
  ];
  var MODEL = /^(a |an )?(man|woman|men|women|two |three |four |five |six |group|couple|people)/i;

  function isModel(img) {
    if (!img) return false;
    var alt = (img.getAttribute('alt') || '').trim();
    return MODEL.test(alt) || /\bon model\b/i.test(alt);
  }
  function backImg(el) { return el && (el.tagName === 'IMG' ? el : el.querySelector('img')); }
  function labels(front, back) {
    var b = backImg(back);
    var src = b ? (b.getAttribute('src') || b.currentSrc || '') : '';
    var backIsFlat = b && !isModel(b) && (/laid flat|flat lay|front view|front of/i.test(b.getAttribute('alt') || '') || /\.png/i.test(src) || isModel(front));
    var studio = b && /studio/i.test(b.getAttribute('alt') || '');
    return {
      off: studio ? 'Studio' : backIsFlat ? 'Flat lay' : 'Next view',
      on: isModel(front) ? 'On model' : 'First view'
    };
  }
  function scrollsSideways(el) {
    for (var e = el.parentElement; e && e !== document.body; e = e.parentElement) {
      if (e.scrollWidth > e.clientWidth + 4) {
        var ox = getComputedStyle(e).overflowX;
        if (ox === 'auto' || ox === 'scroll') return true;
      }
    }
    return false;
  }
  function flip(host, fam, btn, on) {
    var back = host.querySelector(fam.back);
    if (!back) return;
    host.classList.add('ma-flip-ready');
    var img = backImg(back);
    var go = function () {
      requestAnimationFrame(function () {
        host.classList.toggle('ma-flip-on', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    };
    if (on && img && !(img.complete && img.naturalWidth)) {
      img.loading = 'eager';
      img.addEventListener('load', go, { once: true });
      img.addEventListener('error', go, { once: true });
      setTimeout(go, 1200);
    } else go();
  }
  function arm(host, fam) {
    if (host.hasAttribute('data-ma-flip')) return;
    host.setAttribute('data-ma-flip', '');
    if (fam.skip && host.querySelector(fam.skip)) return;
    var back = host.querySelector(fam.back);
    var front = host.querySelector(fam.front);
    if (!back) return;
    var r = host.getBoundingClientRect();
    if (r.width && r.width < 130) return; /* thumbnail-size cards: the chip would cover the garment */
    var l = labels(front, back);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ma-flip';
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', l.off === 'Flat lay' ? 'Show the flat lay' : l.off === 'Studio' ? 'Show the studio shot' : 'Show another view');
    btn.innerHTML = '<span class="ma-flip__off">' + l.off + '</span><span class="ma-flip__on">' + l.on + '</span>';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      flip(host, fam, btn, btn.getAttribute('aria-pressed') !== 'true');
    });
    host.appendChild(btn);

    /* sideways swipe on grid cards (not inside a scrolling rail, where the swipe belongs to the rail) */
    var x0 = 0, y0 = 0, t0 = 0;
    host.addEventListener('touchstart', function (e) {
      var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; t0 = Date.now();
    }, { passive: true });
    host.addEventListener('touchend', function (e) {
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      if (Date.now() - t0 > 700 || Math.abs(dx) < 36 || Math.abs(dx) < Math.abs(dy) * 1.6) return;
      if (host.hasAttribute('data-ma-rail') || scrollsSideways(host)) { host.setAttribute('data-ma-rail', ''); return; }
      flip(host, fam, btn, dx < 0);
    }, { passive: true });
  }
  function scanCards(root) {
    if (!touch.matches) return;
    for (var i = 0; i < FAMILIES.length; i++) {
      var f = FAMILIES[i];
      var hosts = root.querySelectorAll ? root.querySelectorAll(f.host) : [];
      for (var j = 0; j < hosts.length; j++) arm(hosts[j], f);
    }
  }

  /* ---------- 2. Editorial images ---------- */
  function tap(href, label, attrs) {
    var a = document.createElement('a');
    a.className = 'ma-tap';
    a.href = href;
    a.setAttribute('aria-label', label);
    for (var k in attrs || {}) a.setAttribute(k, attrs[k]);
    return a;
  }
  function chip(href, text, attrs) {
    var a = document.createElement('a');
    a.className = 'ma-look';
    a.href = href;
    a.textContent = text;
    for (var k in attrs || {}) a.setAttribute(k, attrs[k]);
    return a;
  }
  function openLook(ch) {
    var d = ch && ch.querySelector('details.cs-look');
    if (!d) return false;
    d.open = true;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var y = d.getBoundingClientRect().top + window.scrollY - 96;
    window.scrollTo({ top: y, behavior: still ? 'auto' : 'smooth' });
    return true;
  }
  function editorial() {
    /* landing heroes /collections/her, /him, /essentials-unisex: the photograph opens the page's own first chapter */
    [].forEach.call(document.querySelectorAll('.ma-lh'), function (root) {
      var media = root.querySelector('.ma-lh__media');
      var cta = root.querySelector('.ma-lh__ctas a');
      if (!media || !cta || media.querySelector('.ma-tap')) return;
      var at = {};
      if (cta.dataset.maJump) at['data-ma-jump'] = cta.dataset.maJump;
      media.appendChild(tap(cta.getAttribute('href'), 'Shop the look', at));
      media.appendChild(chip(cta.getAttribute('href'), 'Shop the look', at));
    });

    /* Athletics Club spread: a frame opens its chapter's Shop the look (hotspots stay above and keep their sheet) */
    [].forEach.call(document.querySelectorAll('.cs-ch[data-cs-ch]'), function (ch) {
      var look = ch.querySelector('details.cs-look');
      var track = look && look.querySelector('.ma-st__track');
      if (!look || !track) return;
      var href = '#' + track.id;
      var h = ch.querySelector('.cs-ch__h');
      var name = h ? h.textContent.trim() : '';
      [].forEach.call(ch.querySelectorAll('.cs-art'), function (art) {
        if (art.querySelector('.ma-tap')) return;
        art.appendChild(tap(href, 'Shop the look' + (name ? ': ' + name : ''), { 'data-ma-look': '' }));
      });
      var fig = ch.querySelector('.cs-fig--a');
      if (fig && !fig.querySelector(':scope > .ma-look')) fig.appendChild(chip(href, 'Shop the look', { 'data-ma-look': '' }));
    });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-ma-look]');
      if (!a) return;
      if (openLook(a.closest('.cs-ch'))) e.preventDefault();
    });

    /* homepage film: the film opens the Essentials; the Her / Him buttons stay on top */
    var hm = document.querySelector('.ma-hero .ma-hero__media');
    if (hm && !hm.querySelector(':scope > .ma-tap') && !hm.closest('a')) {
      hm.appendChild(tap('/collections/shop-all-essentials', 'Shop the Essentials'));
    }
  }

  /* ---------- boot ---------- */
  var queued = false, pending = [];
  function queue(n) {
    pending.push(n);
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      var list = pending; pending = [];
      for (var i = 0; i < list.length; i++) scanCards(list[i]);
    });
  }
  function boot() {
    scanCards(document);
    editorial();
    if ('MutationObserver' in window) {
      new MutationObserver(function (ms) {
        if (!touch.matches) return;
        for (var i = 0; i < ms.length; i++) {
          for (var j = 0; j < ms[i].addedNodes.length; j++) {
            var n = ms[i].addedNodes[j];
            if (n.nodeType === 1 && !(n.classList && (n.classList.contains('ma-flip') || n.classList.contains('ma-tap')))) queue(n.parentElement || n);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    if (touch.addEventListener) touch.addEventListener('change', function () { scanCards(document); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
